import peers from './peers';
import detail from './detail';
import profiles from './profiles';
import create from './create';
import search from './search';

export default [detail, peers, profiles, create, search];
